import { Checkbox as RACCheckbox } from "react-aria-components";

import styles from "./checkbox.module.css";

interface CheckboxProps {
  id?: string;
  name: string;
  isSelected?: boolean;
  onChange?: (isSelected: boolean) => void;
  label?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  value: string;
  /** Names the box for a screen reader when there is no visible `label` (a checkbox in a table row). */
  "aria-label"?: string;
}

function Checkbox({
  name,
  value,
  label,
  onChange,
  id,
  isSelected = false,
  isRequired = false,
  isDisabled = false,
  "aria-label": ariaLabel,
}: CheckboxProps) {
  return (
    <RACCheckbox
      name={name}
      value={value}
      onChange={onChange}
      id={id}
      className={styles.checkbox}
      isSelected={isSelected}
      isRequired={isRequired}
      isDisabled={isDisabled}
      aria-label={ariaLabel}
    >
      <div className={styles.box}>
        <svg className={styles.check} viewBox="0 0 18 18" aria-hidden="true">
          <polyline points="1 9 7 14 15 4" />
        </svg>
      </div>
      {label}
    </RACCheckbox>
  );
}

export default Checkbox;
